// extracted by mini-css-extract-plugin
export default {"banner":"Showcase_banner__qv+1o","image":"Showcase_image__Y1-oE","backBtn":"Showcase_backBtn__v8ALo","nextBtn":"Showcase_nextBtn__UeeTU","App":"Showcase_App__V4jPn"};